import React from "react"
import { useTranslation } from "react-i18next"

import i18n from "config/i18n"
import { Content, Sections } from "pages/static/elements"
import Title from "components/ui/Title"
import { INSTANCE } from "config"
import {
  // NOTE: {{INSTANCE}}_{{LANG}}_Content
  FRESHFINANCE_EE_ET_Content,
  FRESHFINANCE_EE_RU_Content,
  FRESHFINANCE_EE_EN_Content,
} from "pages/static/help/freshfinance_ee"
import {
  FRESHFINANCE_LT_LT_Content,
  FRESHFINANCE_LT_RU_Content,
  FRESHFINANCE_LT_EN_Content,
} from "pages/static/help/freshfinance_lt"
import {
  EE_PUNKFINANCE_ET_Content,
  EE_PUNKFINANCE_RU_Content,
  EE_PUNKFINANCE_EN_Content,
} from "pages/static/help/ee_punkfinance"

const HelpPage = () => {
  const { t } = useTranslation()

  const renderSections = () => {
    switch (INSTANCE) {
      case "freshfinance_ee":
        switch (i18n.language) {
          case "en":
            return <FRESHFINANCE_EE_EN_Content />
          case "ru":
            return <FRESHFINANCE_EE_RU_Content />
          default:
            return <FRESHFINANCE_EE_ET_Content />
        }

      case "freshfinance_lt":
        switch (i18n.language) {
          case "en":
            return <FRESHFINANCE_LT_EN_Content />
          case "ru":
            return <FRESHFINANCE_LT_RU_Content />
          default:
            return <FRESHFINANCE_LT_LT_Content />
        }

      case "ee_punkfinance":
        switch (i18n.language) {
          case "et":
            return <EE_PUNKFINANCE_EN_Content />
          case "ru":
            return <EE_PUNKFINANCE_RU_Content />
          default:
            return <EE_PUNKFINANCE_ET_Content />
        }

      default:
        return <FRESHFINANCE_EE_ET_Content />
    }
  }

  return (
    <Content data-testid="help-page">
      <Title>{t("pages.help.title")}</Title>
      <Sections>{renderSections()}</Sections>
    </Content>
  )
}

export default HelpPage
